import React from "react";
import { LinkContainer } from 'react-router-bootstrap';
// import Wrp from '../../../../hoc/Wrp/Wrp';

const mainMenuComponent = (props) => {
    const emailPage = props.linkPage;
    //let emailPageURL = "/email-settings/email/"+emailPage+'/'+props.windowId
    let emailPageURL = "/email-settings/email/"+emailPage
    // console.log(emailPageURL);
    let inboxTypeText = ''
    if(emailPage === 'inbox'){
        if(props.inboxType !== 'All')
        inboxTypeText = '('+props.inboxType+')';
    }
    // console.log(emailPage,props.inboxType);
    return(
            <LinkContainer to={emailPageURL}>
            {
                props.isMobileWebView === false ?
                <li className={props.activeclass}>
                    <a>
                        <i className={props.icon}></i> {props.name} <span className="text-small text-danger"> {inboxTypeText} </span>                   
                    </a>
                    {
                        props.countDisplay === true ?
                            <span className="badge badge-pill badge-default">{props.count}</span>
                        : null
                    }
                </li>
                :
                <div className="w-100 d-flex align-items-center justify-content-center mb-1">
                    <div className="w-100 ">
                        <label className="w-100 d-flex align-items-center mb-0 cursor-pointer">
                            <span className="pl-2">  {props.name} <span className="text-small text-danger"> {inboxTypeText} </span></span>
                            {
                                props.countDisplay === true ?
                                    <span className="badge badge-pill badge-default">{props.count}</span>
                                : null
                            }
                        </label>
                    </div>                   
                </div> 

            }            
            </LinkContainer>
    )
}

export default mainMenuComponent;